import {
    CHANGE_GENERAL_STORE_SETTINGS, CLOSE_ADMIN_BURGER_MENU,
    CLOSE_ARAG_USER_BURGER_MENU,
    CLOSE_ARAG_USER_SETTINGS_MENU, CLOSE_USER_BURGER_MENU, OPEN_ADMIN_BURGER_MENU, OPEN_ARAG_USER_BURGER_MENU,
    OPEN_ARAG_USER_SETTINGS_MENU, OPEN_SOLICITOR_USER_BURGER_MENU
} from "./index";

export function openAdminBurgerMenu(payload) {
    return {
        type: OPEN_ADMIN_BURGER_MENU,
        payload: payload
    }
}

export function closeAdminBurgerMenu(payload) {
    return {
        type: CLOSE_ADMIN_BURGER_MENU,
        payload: payload
    }
}

export function openUserBurgerMenu(payload) {
    return {
        type: OPEN_SOLICITOR_USER_BURGER_MENU,
        payload: payload
    }
}

export function closeUserBurgerMenu(payload) {
    return {
        type: CLOSE_USER_BURGER_MENU,
        payload: payload
    }
}

export function openAragUserBurgerMenu(payload) {
    return {
        type: OPEN_ARAG_USER_BURGER_MENU,
        payload: payload
    }
}

export function closeAragUserBurgerMenu(payload) {
    return {
        type: CLOSE_ARAG_USER_BURGER_MENU,
        payload: payload
    }
}

export function openAragUserSettingsMenu(payload) {
    return {
        type: OPEN_ARAG_USER_SETTINGS_MENU,
        payload: payload
    }
}

export function closeAragUserSettingsMenu(payload) {
    return {
        type: CLOSE_ARAG_USER_SETTINGS_MENU,
        payload: payload
    }
}

export function changeGeneralStoreSettings(payload) {
    return {
        type: CHANGE_GENERAL_STORE_SETTINGS,
        payload: payload
    }
}